import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { HorizontalHeaders } from "../pages/components/FuturesTable/utils/header.utils";
import useCellTab from "../hooks/useCellTab";
import { ForecastContext } from "./ForecastContext";
import { ShipmentHeaderContext } from "./ShipmentHeaderContext";

export const DistributionContext = createContext<{
  distributionData: Array<Array<number | string>>;
  setDistributionData: (val: Array<Array<number | string>>) => void;
  selectedCell: { row: number; column: number };
  setNextCell: (row: number, column: number) => () => void;
}>({
  distributionData: [[1]],
  setDistributionData: (val) => val,
  selectedCell: { row: -1, column: -1 },
  setNextCell: (row, column) => () => row + column,
});

export const createDefaultDistributionData = (
  horizontalHeaders: HorizontalHeaders,
) => {
  const defaultData = Array(3)
    .fill(0)
    .map((_) => Array(horizontalHeaders.MONTHS.length + 1).fill(0));
  defaultData[0][defaultData.length - 1] = "-";
  return defaultData;
};
export const DISTRIBUTION_COLUMNS = ["DRS %", "DRS", "DC", "Futures Total"];
export const DistributionProvider = ({ children }: { children: ReactNode }) => {
  const { horizontalHeaders, monthsInFirstTwoSeasons } = useContext(
    ShipmentHeaderContext,
  );
  const { originalForecast } = useContext(ForecastContext);
  const DISTRIBUTION_DEFAULT_DATA =
    createDefaultDistributionData(horizontalHeaders);
  const [distributionData, setDistributionData] = useState<
    Array<Array<number | string>>
  >(DISTRIBUTION_DEFAULT_DATA);
  const { selectedCell, setSelectedCell } = useCellTab(
    horizontalHeaders.MONTHS.length,
    DISTRIBUTION_DEFAULT_DATA.length,
  );

  useEffect(() => {
    if (
      originalForecast.dist_method &&
      originalForecast.dist_method.length > 1
    ) {
      const newDistributionData = originalForecast.dist_method.map(
        (forecast) => {
          return forecast.map((month) => month);
        },
      );
      // set the last column of first row to -
      newDistributionData[0].push(-1);
      setDistributionData(newDistributionData);
    }
  }, [originalForecast]);
  const setNextCell = (row: number, column: number) => () => {
    if (
      row === 1 &&
      column >= 0 &&
      column + 1 < horizontalHeaders.MONTHS.length
    ) {
      setSelectedCell({ row: 1, column: column + 1 });
    }
  };
  return (
    <DistributionContext.Provider
      value={{
        distributionData,
        setDistributionData,
        selectedCell,
        setNextCell,
      }}
    >
      {children}
    </DistributionContext.Provider>
  );
};
